<div class="page-header row" [ngClass]="{'close_icon' :navService.collapseSidebar }"
    [ngStyle]="{ 'display' : hideScrollNavService.headerFixed ? 'none' : 'flex'}">
    <div class="header-logo-wrapper col-auto">
        <div class="logo-wrapper">
            <a [routerLink]="['/home']">
                <img class="img-fluid for-light" src="assets/images/logo/logo.png" alt="" />
                <img class="img-fluid for-dark" src="assets/images/logo/logo.png" alt="" /></a>
        </div>
    </div>
    <div class="col-4 col-xl-4 page-title">
        <app-breadcrumb></app-breadcrumb>
    </div>
    <div class="header-wrapper col m-0">
        <div class="row" (clickOutside)="searchService.clickOutside()">
            <div class="header-logo-wrapper col-auto p-0">
                <div class="logo-wrapper">
                    <a [routerLink]="['/home']">
                        <img class="img-fluid" src="assets/images/logo/logo.png" alt=""></a>
                </div>
                <div class="toggle-sidebar" (click)="sidebarToggle()">
                    <app-common-svg-icon [class]="'stroke-icon sidebar-toggle status_toggle middle'"
                        [icon]="'toggle-icon'"></app-common-svg-icon>
                </div>
            </div>
            <div class="nav-right col-xxl-8 col-xl-6 col-md-7 col-8 pull-right right-header p-0 ms-auto">
                <ul class="nav-menus">
                    <!-- <li (click)="!navService.language = !navService.language">
                        <app-language></app-language>
                    </li> -->
                    <li></li>
                    <li>
                        <app-theme-mode></app-theme-mode>
                    </li>
                    <li class="profile-nav onhover-dropdown px-0 py-0">
                        <app-profile></app-profile>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>